// src/components/LoadingSpinner.jsx
// Moderner, medieval-thematischer LoadingSpinner
// Verwendet CSS-Klassen statt Inline-Styles (kein Hydrations-Problem)

import '../styles/base.css';

/**
 * LoadingSpinner – Anzeige während Komponenten geladen werden.
 *
 * Props:
 *   message  – Anzeigetext (default: 'Lade...')
 *   size     – 'sm' | 'md' | 'lg'  (default: 'md')
 *   fullPage – false: nur Inhalt; true: volle Seitenhöhe (default: true)
 */
export default function LoadingSpinner({ message = 'Lade...', size = 'md', fullPage = true }) {
  return (
    <div className={`loading-spinner-container${fullPage ? ' loading-spinner--fullpage' : ''}`}>
      {/* Äußerer Ring */}
      <div className={`loading-spinner loading-spinner--${size}`} aria-hidden="true">
        <div className="loading-spinner__ring loading-spinner__ring--outer" />
        <div className="loading-spinner__ring loading-spinner__ring--inner" />
        {/* D20-Würfel-Symbol in der Mitte */}
        <span className="loading-spinner__icon" aria-hidden="true">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polygon points="12 2 2 12 12 22 22 12 12 2" />
            <polygon points="12 2 12 22" />
            <polygon points="2 12 22 12" />
            <polygon points="12 2 6 12 12 22 18 12 12 2" />
          </svg>
        </span>
      </div>

      {message && (
        <p className="loading-spinner__message" role="status" aria-live="polite">
          {message}
        </p>
      )}
    </div>
  );
}
